export const LEGACY_WIDGET_SDK_PREFIX = 'chatwoot';

export function slugFromInstallationName(name) {
  if (!name) return LEGACY_WIDGET_SDK_PREFIX;

  const first = name.trim().split(/\s+/)[0] || name;
  const slug = first.toLowerCase().replace(/[^a-z0-9]/g, '');

  return slug || LEGACY_WIDGET_SDK_PREFIX;
}

export function getWidgetSdkGlobals(installationName) {
  const prefix = slugFromInstallationName(installationName);

  return {
    prefix,
    settingsGlobal: `${prefix}Settings`,
    sdkGlobal: `${prefix}SDK`,
    apiGlobal: `$${prefix}`,
    readyEvent: `${prefix}:ready`,
  };
}

export function getBrandedPrefix() {
  return window.widgetSdkPrefix || LEGACY_WIDGET_SDK_PREFIX;
}

export function readWidgetSettings() {
  const prefix = getBrandedPrefix();

  if (prefix !== LEGACY_WIDGET_SDK_PREFIX && window[`${prefix}Settings`]) {
    return window[`${prefix}Settings`];
  }

  return window.chatwootSettings || {};
}

export function exposeBrandedSdkAlias() {
  const prefix = getBrandedPrefix();

  if (prefix === LEGACY_WIDGET_SDK_PREFIX) return;

  window[`${prefix}SDK`] = window.chatwootSDK;
}

export function exposeBrandedApiAlias() {
  const prefix = getBrandedPrefix();

  if (prefix === LEGACY_WIDGET_SDK_PREFIX) return;

  window[`$${prefix}`] = window.$chatwoot;
}

export function dispatchWidgetReadyEvents(
  dispatchWindowEvent,
  legacyReadyEvent
) {
  const prefix = getBrandedPrefix();

  if (prefix === LEGACY_WIDGET_SDK_PREFIX) {
    dispatchWindowEvent({ eventName: legacyReadyEvent });
    return;
  }

  dispatchWindowEvent({ eventName: `${prefix}:ready` });
}
